<template>
  <div id="instructor-table-pagination" >
    <el-pagination
      v-if="dynamicDataLoaded"
      id="pagination"
      :current-page.sync="queryParamsInstructors.page"
      :page-sizes="rowsPerPage"
      :page-size="queryParamsInstructors.per_page"
      layout="sizes, prev, pager, next"
      :total="tableData.pagination.total"
      :disabled="instructorAjaxing || selectedData.length > 0 || multiSelect"
      @size-change="sizeChange"
      @prev-click="pageChange"
      @next-click="pageChange"
      @current-change="pageChange"
      class='instructor-table-pagination'
      >
    </el-pagination>
    
    <div>
      <span
        v-if="['Interactions', 'Single-Interaction', 'Gradebook'].includes(activeViewInstructor)"
        style="margin-left:3px; margin-top:4px; line-height: 16px;">
        <span
          style="font-size:16px;">*
        </span>
        <span
          style="position:relative; top: -3px;">Previous attempts exist. See export.
        </span>
      </span>
    </div>
    
  </div>
</template>

<script>
import router from '../../router';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import {
  waitForElementToDisplay
} from '@utilities';

export default {
  name: 'instructor-table-pagination',
  computed: {
    ...mapState('instructors', [
      'multiSelect',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'passbackLinking',
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'instructorAjaxing',
      'queryParamsInstructors',
      'selectedData',
      'dynamicDataLoaded',
      'gradebook',
      'classes',
      'bulbs',
      'folders',
      'students',
      'premade',
      'bulbattempts',
      'interactions',
      'studentbulbattempts',
      'singleinteraction',
      'studentinteraction',
      'gradebookBreadcrumbs',
      'videos',
      'community',
      'lmb',
      'peerreview',
      'playlists',
      'singlefolder',
      'subfolder'
    ]),
    rowsPerPage () {
      if (this.tableData.pagination.total <= 20) return [this.tableData.pagination.total];
      if (this.tableData.pagination.total > 20 && this.tableData.pagination.total <= 40) return [20, this.tableData.pagination.total];
      if (this.tableData.pagination.total > 40 && this.tableData.pagination.total <= 60) return [20, 40, this.tableData.pagination.total];
      if (this.tableData.pagination.total > 60) return [20, 40, 60, this.tableData.pagination.total];
      if (this.tableData.pagination.total > 100 && (['Premade-Bulbs', 'My-Community'].includes(this.activeViewInstructor) ) ) return [20, 40, 60, 80, 100];
      return this.tableData.pagination.total;
    },
    tableData: function(){
      //total data based on active view
      switch (this.activeViewInstructor) {
        case 'Gradebook':
          return this.gradebook;
        case 'Interactions':
        case 'Learner-Made-Bulb-Monitor':
          return this.interactions;
        case 'Learner-Made-Bulb':
          return this.lmb;
        case 'Student-Bulb-Attempts':
          return this.studentbulbattempts;
        case 'Single-Interaction':
          return this.singleinteraction;
        case 'Student-Interaction':
          return this.studentinteraction;
        case 'Classes':
          return this.classes;
        case 'My-Bulbs':
          return this.bulbs;
        case 'Bulb-Attempts':
          return this.studentbulbattempts;
        case 'Folders':
          return this.folders;
        case 'Folder':
          return this.singlefolder;
        case 'Subfolder':
          return this.subfolder;
        case 'Premade-Bulbs':
          return this.premade;
        case 'Premade-Bulbs-Legacy':
          return this.premade;
        case 'Learners':
          return this.students;
        case 'Bulbs':
          return this.bulbs;
        case 'My-Videos':
          return this.videos;
        case 'My-Community':
          return this.community;
        case 'My-Community-Legacy':
          return this.community;
        case 'Peer-Review':
          return this.peerreview;
        case 'Playlists':
          return this.playlists;
        default:
          console.log("Error: Please add total to instructor pagination switch statement")
          return 0;
      }
    },
  },
  methods:{
    sizeChange: function(event){
      //record page size change and sets query params
      let queryParams = {per_page:event, page:1};
      this.$store.commit('instructors/setQueryParams', queryParams);
      if(this.activeViewInstructor != 'Premade-Bulbs' && this.activeViewInstructor != 'My-Community' && this.activeViewInstructor != 'My-Community-Legacy' && this.activeViewInstructor != 'Premade-Bulbs-Legacy'){
        this.$store.dispatch('instructors/getTableData');
      } else {
        this.$store.dispatch('instructors/getPremadeTableData', {});
      }
      this.$store.dispatch('instructors/updateUrl');
    },
    pageChange: function(event){
      //record page change and sets query params
      let queryParams = { page: event };

      //sets query params to state, calls for data, and updates url
      this.$store.commit('instructors/setQueryParams', queryParams);
      if (this.activeViewInstructor != 'Premade-Bulbs' && this.activeViewInstructor != 'My-Community' && this.activeViewInstructor != 'My-Community-Legacy' && this.activeViewInstructor != 'Premade-Bulbs-Legacy') {
        this.$store.dispatch('instructors/getTableData');
      } else {
        this.$store.dispatch('instructors/getPremadeTableData', {});
      }
      this.$store.dispatch('instructors/updateUrl');
    },
  },
  async updated() {
    const previousPageButton = await waitForElementToDisplay('.btn-prev');
    if (previousPageButton) previousPageButton[0].ariaLabel = 'Previous pagination page';
    const nextPageButton = await waitForElementToDisplay('.btn-next');
    if (nextPageButton) nextPageButton[0].ariaLabel = 'Next pagination page';
  },
};
</script>

<style scoped>
  #instructor-table-pagination{
   padding: 0px 90px 0px 36px;
   height: 60px;
   min-width: 900px;
   display: flex;
   flex-flow: row;
   justify-content: center;
   align-items: center;
  }

  #pagination button {
    background-color: #fafafa !important;
  }

  #pagination ul {
    background-color: #fafafa !important;
  }
  
  .instructor-table-pagination {
    z-index: 1 !important;
  }
</style>


